module.exports = new __parcel__URL__("battlepass_active_button.15a62877.png").toString();